var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('form-datepicker',{attrs:{"value":_vm.selectedDate,"index":"test","type":"datetime"},on:{"input":_vm.selectedDateChanged}}),_c('div',[_c('h3',[_vm._v("ITEM JSON")]),_c('p',{staticClass:"responseText"},[_vm._v(" "+_vm._s(_vm.selectedDate)+" "+_vm._s(_vm.formatedDate)+" ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }